import {
  FetchItemsFilters,
  FetchItemsSort,
  FetchItemsPage,
  FetchItemsLimit,
  FetchItemsGqlQuery
} from '../../../../../types';

import { generateUuid } from '../../../../../utils/generateUuid';
import { getQueryName } from '../../../../../utils/getQueryName';
import { productionConsole } from '../../../../../utils/productionConsole';

import { graphQLEdClient } from '../../graphQLClients';

interface FetchEdItemsProps {
  query: FetchItemsGqlQuery;
  filters: FetchItemsFilters;
  sort: FetchItemsSort;
  page: FetchItemsPage;
  limit: FetchItemsLimit;
}

export function fetchEdItems({
  query,
  filters,
  sort,
  page,
  limit,
  ...additionalParams
}: FetchEdItemsProps) {
  const { rawName, name } = getQueryName(query);

  productionConsole(
    'log',
    'fetchEdItems',
    { filters, sort, page, limit, ...additionalParams },
    { rawName, name },
    JSON.stringify(filters)
  );

  const requestId = generateUuid();

  graphQLEdClient.addQueryParams(name, requestId);

  return graphQLEdClient.request(
    query,
    {
      filters,
      sort,
      limit,
      offset: (page - 1) * limit,
      ...additionalParams
    },
    { requestId }
  );
}
